import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAppContext } from "../../context/AppContext";
import { useAuthContext } from "../../context/AuthContext";
import {
  showQuestionsAnnouncement,
  showTrailExpireAnnouncement,
} from "../../utils/Utils";
import {
  AnnouncementMaintenance,
  AnnouncementQuestonPending,
  AnnouncementTrailExpireSoon,
} from "./Announcement";
import Footer from "./Footer";
import Header from "./Header";
import Main from "./Main";

function Layout({ children }) {
  const toastContextClass = {
    success: "bg-green-200 text-green-600",
    error: "bg-red-200 text-red-600",
    info: "bg-gray-600",
    warning: "bg-orange-200 text-orange-500",
    default: "bg-primary-blue text-white",
    dark: "bg-primary-white font-gray-300",
    notification: "bg-customGray-800 text-white",
  };
  const auth = useAuthContext();
  const appState = useAppContext();
  return (
    <div
      className={`flex flex-col h-screen z-0 ${
        appState.state.darkMode ? "dark" : ""
      } overflow-y-scroll`}
      id="main-container"
    >
      <nav className="mt-0 fixed w-full z-20 top-0">
        {showQuestionsAnnouncement(auth.state.user) ? (
          <AnnouncementQuestonPending />
        ) : showTrailExpireAnnouncement(auth.state.user) ? (
          <AnnouncementTrailExpireSoon />
        ) : null}
        <Header />
      </nav>
      <Main>{children}</Main>
      <Footer />
      <ToastContainer
        toastClassName={({ type }) =>
          toastContextClass[type || "default"] +
          " font-Nato-Sans flex flex-row  p-1 min-h-10 rounded-md justify-between overflow-hidden cursor-pointer"
        }
        bodyClassName={() => " flex flex-row font-bold inline p-3"}
        position="top-center"
        hideProgressBar={true}
        autoClose={3000}
      />
    </div>
  );
}

export default Layout;
